<template>
  <div
    class="flex overflow-x-hidden pt-8 pb-16 lg:pt-28 lg:pb-0 font-rubik bg-themeComponentBg-light"
    ref="scrollContainer"
    @mouseenter="pauseScroll"
    @mouseleave="resumeScroll"
  >
    <div
      v-for="(imageSet, setIndex) in duplicatedImageSets"
      :key="setIndex"
      class="flex items-center flex-shrink-0 gap-2 lg:gap-4 pr-4 lg:pr-4"
    >
      <div class="flex-shrink-0">
        <div
          v-if="imageSet[0]"
          class="bg-[#EDE9E3] rounded-xl flex flex-col items-center justify-center w-[198px] h-[332px] lg:w-[316px] lg:h-[475px]"
        >
          <img :src="imageSet[0].primary_photo" alt="">
        </div>
      </div>
      <div class="flex flex-col flex-shrink-0 gap-2 lg:gap-4">
        <div
          v-if="imageSet[1]"
          class="bg-[#EDE9E3] rounded-xl flex flex-col items-center justify-center w-[108px] h-[108px] lg:w-[216px] lg:h-[216px]"
        >
          <img :src="imageSet[1].primary_photo" alt="">
        </div>
        <div
          v-if="imageSet[2]"
          class="bg-[#EDE9E3] rounded-xl flex flex-col items-center justify-center w-[108px] h-[108px] lg:w-[216px] lg:h-[216px]"
        >
          <img :src="imageSet[2].primary_photo" alt="">
        </div>
      </div>
      <div class="flex-shrink-0">
        <div
          v-if="imageSet[3]"
          class="bg-[#EDE9E3] rounded-xl flex flex-col items-center justify-center w-[144px] h-[193px] lg:w-[316px] lg:h-[316px]"
        >
          <img :src="imageSet[3].primary_photo" alt="">
        </div>
      </div>
      <div class="flex-shrink-0">
        <div
          v-if="imageSet[4]"
          class="bg-[#EDE9E3] rounded-xl flex flex-col items-center justify-center w-[216px] h-[362px] lg:w-[432px] lg:h-[724px]"
        >
          <img :src="imageSet[4].primary_photo" alt="">
        </div>
      </div>
      <div class="flex-shrink-0">
        <div
          v-if="imageSet[5]"
          class="bg-[#EDE9E3] rounded-xl flex flex-col items-center justify-center w-[158px] h-[211px] lg:w-[316px] lg:h-[422px]"
        >
          <img :src="imageSet[5].primary_photo" alt="">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    products: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      scrollSpeed: 1.5, // (pixels per frame)
      animationFrameId: null,
      isPaused: false,
      duplicatedImageSets: [],
      validProducts: [],
      isLoading: true
    }
  },
  computed: {
    imageSets() {
      const sets = []
      for (let i = 0; i < this.validProducts.length; i += 6) {
        sets.push(this.validProducts.slice(i, i + 6))
      }
      return sets
    }
  },
  methods: {
    preloadImage(url) {
      return new Promise((resolve) => {
        const img = new Image()
        img.src = url
        img.onload = () => resolve(true)
        img.onerror = () => resolve(false) // Resolve as false on error
      })
    },
    async validateAndFilterProducts() {
      // Some images links are broken and don't open, this method checks and filters out those images
      const validationPromises = this.products.map(async (product) => {
        const isValid = await this.preloadImage(product.primary_photo)
        return isValid ? product : null
      })

      const results = await Promise.all(validationPromises)
      this.validProducts = results.filter(product => product !== null)
      this.isLoading = false
    },
    duplicateImageSets() {
      this.duplicatedImageSets = [...this.imageSets, ...this.imageSets, ...this.imageSets]
    },
    startScrolling() {
      const container = this.$refs.scrollContainer
      const step = () => {
        if (!this.isPaused) {
          container.scrollLeft += this.scrollSpeed
          // When scrollLeft exceeds half of scrollWidth, reset to 0
          if (container.scrollLeft >= container.scrollWidth / 2) {
            container.scrollLeft = 0
          }
        }
        this.animationFrameId = requestAnimationFrame(step)
      }
      this.animationFrameId = requestAnimationFrame(step)
    },
    stopScrolling() {
      cancelAnimationFrame(this.animationFrameId)
    },
    pauseScroll() {
      this.isPaused = true
    },
    resumeScroll() {
      this.isPaused = false
    }
  },
  async mounted() {
    await this.validateAndFilterProducts()
    this.duplicateImageSets()
    this.startScrolling()
  },
  beforeUnmount() {
    this.stopScrolling()
  }
}
</script>

<style scoped>
/* Hides scrollbar */
::-webkit-scrollbar {
  height: 0px;
}

::-webkit-scrollbar-thumb {
  background-color: #cbd5e0;
  border-radius: 4px;
}

/* Prevent text selection while scrolling */
.flex {
  user-select: none;
}
</style>